import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserOrders } from "../../slices/orders";
import { OrderTile } from "../helpers/OrderTile";
import OrderView from "../order/OrderView";
import {
  Center,
  Spinner,
  Text,
  Alert,
  AlertDescription,
} from "@chakra-ui/react";
import { MdInbox } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import EmptyState from "../helpers/EmptyState";
import { fetchCurrentUser } from "../../slices/users";

export default function Orders() {
  const dispatch = useDispatch();
  const { orders, status, error } = useSelector((state) => state.orders);
const navigate = useNavigate();

  const [viewOrder, setViewOrder] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchUserOrders());
       dispatch(fetchCurrentUser());
    }
  }, [status, dispatch]);

  if (viewOrder) {
    return (
      <OrderView order={selectedOrder} onClose={() => setViewOrder(false)} />
    );
  }

  if (status === "loading") {
    return (
      <Center minH="200px" flexDirection="column">
        <Spinner color="teal.500" size="lg" />
        <Text mt={3} color="gray.600">
          Fetching your order history.
        </Text>
      </Center>
    );
  }

  if (status === "failed") {
    return (
      <Alert
        status="error"
        variant="left-accent"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        py={10}
        borderRadius="md"
      >
        <Text fontWeight="bold" fontSize="lg" mt={2} mb={1}>
          Could not load orders!
        </Text>
        <AlertDescription maxWidth="sm">
          Something went wrong. Please check your connection or try again later.
          <Text as="span" fontSize="sm" color="red.700" display="block" mt={1}>
            Details: {error}
          </Text>
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div
      className="row p-2 address-list-container gap-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2"
      
    >
      {orders.length > 0 ? (
        orders.map((order) => (
          <div
            key={order.id}
            onClick={() => {
              setViewOrder(true);
              setSelectedOrder(order);
            }}
          >
            <OrderTile
              id={order.id}
              date={new Date(order.created_at).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
              orderNumber={order.order_number}
              status={order.status}
              total={`₹ ${order.final_total}`}
              items={order.items}
            />
          </div>
        ))
      ) : (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
     <EmptyState
  title="No Orders Found"
  description="You don’t have any orders yet. Start shopping to see your orders here!"
  buttonText="Go to Shop"
  onButtonClick={() => navigate("/shop")}
  icon={MdInbox}
/></div>

      )}
    </div>
  );
}
